import { useEffect, useRef } from "react";

export default function HiddenTripPage() {
  const containerRef = useRef(null);

  useEffect(() => {
    fetch("/x2158acd0fddc5dfb.html")
      .then((res) => res.text())
      .then((html) => {
        if (containerRef.current) {
          const iframe = document.createElement("iframe");
          iframe.style.cssText = "width:100%;height:100vh;border:none;";
          iframe.srcdoc = html;
          containerRef.current.innerHTML = "";
          containerRef.current.appendChild(iframe);
        }
      });
  }, []);

  return <div ref={containerRef} style={{ width: "100%", height: "100vh" }} />;
}
